export var mailSettingsCacheKey = "mail-settings";
